import { FC, memo } from 'react'
// import { Box } from '@chakra-ui/react'
import { createIcon } from '@chakra-ui/icons'

import { CustomIconProps } from 'types'
import CustomIcon from '../../CustomIcon'

const FolderClockOutline = createIcon({
  displayName: 'FolderClockOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0 0h24v24h-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M7.5 21l-1.96701e-07-3.55271e-15c-2.48528-1.08635e-07-4.5-2.01472-4.5-4.5 1.08635e-07-2.48528 2.01472-4.5 4.5-4.5 2.48528 1.08635e-07 4.5 2.01472 4.5 4.5l3.55271e-15-1.96701e-07c0 2.48528-2.01472 4.5-4.5 4.5"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M7.393 14.983v1.758l1.382.843"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M15 19h4l-8.74228e-08-3.55271e-15c1.10457 4.82823e-08 2-.89543 2-2v-9.06 -8.88178e-16c0-1.10457-.895431-2-2-2h-6.471l5.06946e-09-2.57128e-12c-.332272.000168565-.642928-.164715-.829-.44l-1.4-2.063 -1.47521e-09-2.16556e-09c-.186752-.274145-.497291-.437843-.829-.437h-4.471l-8.74228e-08 1.77636e-15c-1.10457 4.82823e-08-2 .895431-2 2v5"
        ></path>
      </g>
    </>
  ),
})

const FolderClock: FC<CustomIconProps> = (props) => {
  // if (props.variant === 'twoTone') return <CustomIcon as={FolderClockTwoTone} {...props} />

  return <CustomIcon as={FolderClockOutline} {...props} />
}

export default memo(FolderClock)
